import { Banner } from '@components/display/banners/Banner';
import { useGetOverviewBannerQuery } from '@overview/services';
import { Link } from 'react-router-dom';

const OverviewBanner = () => {
    const { data, isLoading: isBannerLoading } = useGetOverviewBannerQuery();

    const isBannerPublished = !!data && !isBannerLoading;

    return isBannerPublished || isBannerLoading ? (
        <Banner
            className="px-5 md:px-[65px] mt-6"
            loading={isBannerLoading}
            data={data ?? {}}
            buttonProps={
                data?.button_link
                    ? data.button_link.includes('/app')
                        ? { LinkComponent: Link, to: data?.button_link }
                        : { href: data?.button_link }
                    : undefined
            }
        />
    ) : null;
};

export { OverviewBanner };
